(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './add', './divide', './multiply', './subtract'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./add'), require('./divide'), require('./multiply'), require('./subtract'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.add, global.divide, global.multiply, global.subtract);
    global.index = mod.exports;
  }
})(this, function (exports, _add, _divide, _multiply, _subtract) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.subtract = exports.multiply = exports.divide = exports.add = undefined;
  exports.add = _add.add;
  exports.divide = _divide.divide;
  exports.multiply = _multiply.multiply;
  exports.subtract = _subtract.subtract;
});